import { AboutUsBanner } from '../components/molecules/aboutUsBanner/AboutUsBanner';
import { AboutUsTeam } from '../components/molecules/aboutUsTeam/AboutUsTeam';

export const AboutUsNew = () => {
  return (
    <>
      <AboutUsBanner />
      <AboutUsTeam />
    </>
  );
};
